module.exports = __webpack_public_path__ + "img/sky4.586a430c.png";